
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1mabk_3450l_99",
  "radio": "awsui_radio_1mabk_3450l_135",
  "radio--has-description": "awsui_radio--has-description_1mabk_3450l_143",
  "radio-control": "awsui_radio-control_1mabk_3450l_147",
  "outline": "awsui_outline_1mabk_3450l_155",
  "styled-circle-border": "awsui_styled-circle-border_1mabk_3450l_177",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_3450l_181",
  "styled-circle-fill": "awsui_styled-circle-fill_1mabk_3450l_186",
  "styled-circle-checked": "awsui_styled-circle-checked_1mabk_3450l_192"
};
  